import axios from 'axios'
import CryptoJS from 'crypto-js'

const ENC_MODE = (process.env.VUE_APP_ENCRYPTION_MODE || 'required').toLowerCase()
//! Importante la Encrytion key tiene que ser la misma con el back
//! De no ser la misma habra error  en el proceso de encriptar
const keyString = process.env.VUE_APP_APIKEY || '' 
const key = CryptoJS.SHA256(keyString)

const secureApi = axios.create({
  baseURL: process.env.VUE_APP_URL_BACKEND + 'api/',
  withCredentials: true
})

function encryptData(obj) {
  if (!keyString) return obj
  const iv = CryptoJS.lib.WordArray.random(16)
  const plaintext = JSON.stringify(obj)
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
  })
  const ciphertext = CryptoJS.enc.Base64.parse(encrypted.toString())
  const combined = iv.clone().concat(ciphertext)
  return CryptoJS.enc.Base64.stringify(combined)
}
function decryptData(b64) {
  if (!keyString) return b64
  const combined = CryptoJS.enc.Base64.parse(b64)
  const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4), 16)
  const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4), combined.sigBytes - 16)
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

secureApi.interceptors.request.use((config) => {
  if (ENC_MODE === 'off') return config
  config.headers['X-Encrypted'] = '1'
  if (config.data instanceof FormData) {
    const plain = {}
    for (const [k, v] of config.data.entries()) {
      try { plain[k] = JSON.parse(v) } catch { plain[k] = v }
    }
    const fd = new FormData()
    fd.append('data', encryptData(plain))
    config.data = fd
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config.data) {
    config.data = { data: encryptData(config.data) }
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})

secureApi.interceptors.response.use((response) => {
  if (ENC_MODE === 'off') return response
  if (response.data?.data) {
    try {
      const jsonStr = decryptData(response.data.data)
      response.data = JSON.parse(jsonStr)
    } catch (e) {console.log(e)}
  }
  return response
})

export default secureApi